import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "fixed inset-0 z-50 overflow-y-auto px-4 py-6 sm:px-0",
    "scroll-region": ""
};
const _hoisted_2 = { class: "mb-6 transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:mx-auto sm:w-full" };
import { onMounted, onUnmounted, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Modal',
    props: {
        show: { type: Boolean, default: false },
        maxWidth: { default: '2xl' },
        closeable: { type: Boolean, default: true }
    },
    emits: ['close'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const dialog = ref();
        const showSlot = ref(props.show);
        watch(() => props.show, () => {
            if (props.show) {
                document.body.style.overflow = 'hidden';
                showSlot.value = true;
                dialog.value?.showModal();
            }
            else {
                document.body.style.overflow = '';
                setTimeout(() => {
                    dialog.value?.close();
                    showSlot.value = false;
                }, 200);
            }
        });
        const close = () => {
            if (props.closeable) {
                emit('close');
            }
        };
        const closeOnEscape = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                if (props.show) {
                    close();
                }
            }
        };
        onMounted(() => document.addEventListener('keydown', closeOnEscape));
        onUnmounted(() => {
            document.removeEventListener('keydown', closeOnEscape);
            document.body.style.overflow = '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("dialog", {
                class: "z-50 m-0 min-h-full min-w-full overflow-y-auto bg-transparent backdrop:bg-transparent",
                ref_key: "dialog",
                ref: dialog
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_Transition, {
                        "enter-active-class": "ease-out duration-300",
                        "enter-from-class": "opacity-0",
                        "enter-to-class": "opacity-100",
                        "leave-active-class": "ease-in duration-200",
                        "leave-from-class": "opacity-100",
                        "leave-to-class": "opacity-0"
                    }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", {
                                class: "fixed inset-0 transform transition-all",
                                onClick: close
                            }, [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
                                ]))], 512), [
                                [_vShow, __props.show]
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_Transition, {
                        "enter-active-class": "ease-out duration-300",
                        "enter-from-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-active-class": "ease-in duration-200",
                        "leave-from-class": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_2, [
                                (showSlot.value)
                                    ? _renderSlot(_ctx.$slots, "default", { key: 0 })
                                    : _createCommentVNode("", true)
                            ], 512), [
                                [_vShow, __props.show]
                            ])
                        ]),
                        _: 3
                    })
                ])
            ], 512));
        };
    }
});
